import type { ChatChannelEligibility } from "Infrastructure/Api/Api";

/**
 * The group's membership rule as Stream carries it in the channel's custom data (mirrors the
 * backend's ChatChannelEligibility; the API itself speaks the enum, this is the channel-data
 * spelling). Keyed by the enum's members, so a value added on one side is missed on the other at
 * compile time.
 */
export const ChannelEligibility = {
  Anyone: "anyone",
  FullMooneOnly: "fullMooneOnly",
} as const satisfies Record<keyof typeof ChatChannelEligibility, string>;

export type ChannelEligibility =
  (typeof ChannelEligibility)[keyof typeof ChannelEligibility];
